// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1luZh","content":"styles_content__XerZW","checkbox":"styles_checkbox__3TYA3","checkboxLabel":"styles_checkboxLabel__3_zsb"};